<template>
  <div class="flex items-center justify-center h-full">
    <button
      class="preview-btn"
      :class="{ 'preview-btn--expanded': isExpanded }"
      :aria-expanded="isExpanded"
      aria-label="Preview"
      @click.stop="togglePreview"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        class="preview-icon"
        aria-hidden="true"
      >
        <path
          d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isExpanded: false,
    };
  },
  beforeMount() {
    this.updateExpanded();
  },
  methods: {
    refresh() {
      this.updateExpanded();
      return true;
    },
    updateExpanded() {
      if (this.params.isExpanded) {
        this.isExpanded = this.params.isExpanded(this.params.data);
      }
    },
    togglePreview() {
      if (this.params.onTogglePreview) {
        this.params.onTogglePreview(this.params.data);
        this.updateExpanded();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.preview-btn {
  @apply p-2 rounded-full transition-colors duration-200 text-gray-dark;

  &:hover {
    @apply bg-gray-light text-gray-darkest;
  }

  &--expanded {
    @apply bg-gray-light text-primary;
  }
}

.preview-icon {
  @apply w-5 h-5;
}
</style>
